<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <transport-route-form />
  </v-container>
</template>

<script>
import TransportRouteForm from './_Form'
export default {
  name: 'OrderTransportRouteEdit',
  components: {TransportRouteForm},
  mixins: [],
  props: {},
  data() {
    return {
      breadcrumbs: [
        { text: 'ルート一覧', disabled: false, to: '/driver/masters/transport_routes', exact: true },
        { text: 'ルート編集', disabled: true, to: '' },
      ],
    }
  },
  computed: {},
  watch: {},
  created() {
  },
  methods: {}
}
</script>

<style scoped>

</style>
